import React from 'react';
import PropTypes from 'prop-types';

const ArrayChipField = ({ record = {}, source }) => {
  if (!record[source]) {
    return <span />;
  }
  return record[source].map(item => (
    <span className="chip" key={item}>
      {item}
    </span>
  ));
};

ArrayChipField.propTypes = {
  record: PropTypes.object,
  source: PropTypes.string.isRequired,
};

export default ArrayChipField;



// WEBPACK FOOTER //
// ./src/resources/ui/ArrayChipField.js